export default __webpack_public_path__ + "static/media/dwld.ac2f46d3.svg";